// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card-header[data-v-717f32eb]{padding:1.25rem 1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
